module.exports = __webpack_public_path__ + "img/cmdarmband.0dd75c3f.jpg";